// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_on_fileLoad from "../eventHandlers/eh_on_fileLoad";
import eh_on_progress from "../eventHandlers/eh_on_progress";
import eh_on_complete from "../eventHandlers/eh_on_complete";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_loader", inline: true };
const loggerMsgs = {
  initStart: ["init. loader"],
  initSuccess: ["init. loader", "init. success"],
  noValidDOMEl: ["init. loader", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_loader() {
  // Setup...
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  // ...

  // Create preloadJs queue instance...
  const loadQueue = new createjs.LoadQueue(true);

  // Listen to instance events...
  loadQueue.on("fileload", eh_on_fileLoad.bind(this), this);
  loadQueue.on("progress", eh_on_progress.bind(this), this);
  loadQueue.on("complete", eh_on_complete.bind(this), this);

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
  return loadQueue;
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
